<template>
  <div class="downLoad">
    <div class="title">下载批量生成的推广链接汇总表</div>
    <el-table v-loading="listLoading" :data="list" fit highlight-current-row>
      <el-table-column label="创建时间" align="center" min-width="100">
        <template slot-scope="{row}">
          <span>{{ row.ctime || '' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="链接数量" align="center" min-width="80">
        <template slot-scope="{row}">
          <span>{{ row.num || ''}}</span>
        </template>
      </el-table-column>
      <el-table-column label="推广位" align="center" min-width="160">
        <template slot-scope="{row}">
          <span>{{ row.positionName || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="推广渠道" align="center" min-width="160">
        <template slot-scope="{row}">
          <span>{{ row.channelName || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="80px">
        <template slot-scope="{row}">
          <el-button type="text" size="mini" @click="dowmLoad(row.batchNo)" class="btnsStyle">下载</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="btn">
      <el-button type="primary" @click="cancel">关闭</el-button>
    </div>
  </div>
</template>

<script>
import Cookie from 'js-cookie';
import { groupByBatchNo } from "@/services/link";
import { exportExcel } from "@/services/downExcel";
import { getTeamCode } from '@/utils/auth'
import { delUndefined, timestampToDateTotal } from "@/utils/utils";
export default {
  name: 'downLoad',
  data() {
    return {
      list: [],
      listLoading: false
    }
  },
  async created() {
    this.getListNew()
  },
  methods: {
    alertBox(msg) {
      this.$confirm(msg, '', {
        distinguishCancelAndClose: true,
        showConfirmButton: false,
        cancelButtonText: '关闭'
      })
        .then(() => {
          console.log()
        })
        .catch(() => {
          console.log()
        });
    },
    timestampToDate(time) {
      return timestampToDateTotal(time)
    },
    getListNew() {
      this.listLoading = true;
      const params = {
        teamCode: getTeamCode()
      }
      groupByBatchNo(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0 && res.data.data.length > 0) {
          this.listLoading = false;
          this.list = res.data.data || [];
        } else if (res.data && res.data.errCode === 1016) {
          this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.listLoading = false;
          this.list = [];
        }
      });
    },
    dowmLoad(batchNo) {
      if (!navigator.onLine) {
        this.alertBox('网络异常，请检查网络')
        return
      }
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.6)'
      });
      const baseParams = {
        batchNo,
        teamCode: getTeamCode()
      }
      exportExcel({
        params: delUndefined(baseParams),
        apiPath: 'agent/link/list/excelByBatchNo'
      }).then(res => {
        if (res.data && res.data.errCode && Number(res.data.errCode) > 0) {
          this.loading.close();
          this.alertBox(`导出失败${res.data.errMsg ? `，${res.data.errMsg}` : ''}`)
          return
        }
        if (res.data && res.data.type && res.data.type === 'application/json') {
          this.loading.close();
          const fr = new FileReader()
          fr.onload = (e) => {
            const result = e && e.target && e.target.result ? JSON.parse(e.target.result) : null
            this.alertBox(`导出失败${result && result.errMsg ? `，${result.errMsg}` : ''}`)
          }
          fr.readAsText(res.data)
          return
        }
        if (res) {
          setTimeout(() => {
            this.loading.close();
          }, 1000)
          const blob = new Blob([res]);
          const downloadElement = document.createElement('a');
          const objectUrl = window.URL.createObjectURL(blob); // 创建下载的链接
          downloadElement.href = objectUrl;
          downloadElement.download = `推广链接汇总表.csv`; // 下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl);
        }
      });
    },
    cancel () {
      this.$emit('handleResult', 'close')
    },
  }
}
</script>

<style scoped lang="less">
.downLoad{
  .title{
    margin-top: -30px;
    font-size: 16px;
  }
  .btnsStyle{
    color:#FF9900;
  }
}
.btn {
  text-align: right;
  margin-top: 50px;
}
</style>
